import React from "react";
import { motion } from "framer-motion";

export const Section = ({ children, className = "", ...props }) => (
  <section className={`max-w-7xl mx-auto px-5 sm:px-8 ${className}`} {...props}>
    {children}
  </section>
);

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <div className="bg-accent/50 border-b border-border">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-12 text-center">
      {eyebrow && (
        <span className="inline-block text-sm font-medium tracking-wide text-primary uppercase mb-3">{eyebrow}</span>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="font-heading text-4xl sm:text-5xl font-semibold text-foreground max-w-3xl mx-auto"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-5 text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </div>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ScrollToTop = ({ children }) => children;
